import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const ESGReportingAndDisclosures = () => {
  const serviceData = {
    title: "ESG Reporting & Disclosures",
    heading: "ESG Reporting & Disclosures",
    image: subTopicImages["ESG Reporting & Disclosures"],
    intro: "",
    description: [
      "We support companies in preparing clear, complete and reliable ESG disclosures that meet both Indian and international expectations.",
    ],
    services: [
      {
        title: "We Assist With",
        list: [
          "SEBI-BRSR reporting and sustainability statements",
          "ESG data mapping, documentation & validation",
          "governance structures for ESG reporting",
          "investor-ready disclosures and Board reports",
        ],
        extraInfo:
          "Our focus is on accurate, consistent and trustworthy ESG communication.",
      },
    ],
    benefitsIntro: "",
    benefits: [],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default ESGReportingAndDisclosures;
